var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{staticClass:"tools-page",attrs:{"padding":""}},[_c('t-header',{attrs:{"title":"Log"}}),_c('q-card',[_c('q-card-section',{staticClass:"q-py-sm"},[_c('log-filter',{attrs:{"data":_vm.data}})],1)],1),_c('div',{staticStyle:{"padding-top":"16px"}}),_c('q-card',[_c('q-card-section',[_c('log-table',{attrs:{"data":_vm.data}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }